import { Spinner } from '@factorialco/deprecated-design-system'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { usePayrollModuleAvailability } from 'modules/marketplace/hooks/usePayrollModuleAvailability'

import { ExternalIntegrationInstallButton } from '../ExternalIntegrationInstallButton'
import { InternalIntegrationInstallationButton } from '../InternalIntegrationInstallationButton'
import { UpsellableIntegration } from '../UpsellModal/upsellableIntegrations'
import { UpsellModalButton } from '../UpsellModalButton'

interface ButonSelectorInterface {
  upsellableIntegration?: UpsellableIntegration
  setUpsellModalVisible: (visible: boolean) => void
  integration: ItemIntegrationFragment
}

export const ButtonSelector = ({
  upsellableIntegration,
  setUpsellModalVisible,
  integration,
}: ButonSelectorInterface) => {
  const { loading, featureAvailability: upsellingFeature } = useFeatureAvailability(
    upsellableIntegration?.id || ''
  )

  const { isPayrollCategoryIntegration, shouldShowPayrollUpsell, hasPayrollModulesAvailable } =
    usePayrollModuleAvailability(integration)

  const upsellButtonClick = () => {
    setUpsellModalVisible(true)
    track(trackingEvents.marketplace.clickIntegrationShowUpsellModal)
  }

  if (loading) return <Spinner />

  if (shouldShowPayrollUpsell) {
    return <UpsellModalButton openUpsellModal={upsellButtonClick} />
  }

  // Special handling for Payroll integrations with modules available
  if (isPayrollCategoryIntegration && hasPayrollModulesAvailable) {
    if (integration.installable) {
      return <InternalIntegrationInstallationButton integration={integration} />
    } else {
      if (!upsellingFeature.available) {
        return <ExternalIntegrationInstallButton integration={integration} />
      }
      return null
    }
  }

  if (integration.installable) {
    if (!upsellableIntegration || (upsellableIntegration && upsellingFeature.available)) {
      return <InternalIntegrationInstallationButton integration={integration} />
    }
    return <UpsellModalButton openUpsellModal={upsellButtonClick} />
  }

  if (!integration.installable) {
    if (!upsellableIntegration) {
      return <ExternalIntegrationInstallButton integration={integration} />
    }

    if (!upsellingFeature.available) {
      return <UpsellModalButton openUpsellModal={upsellButtonClick} />
    }
  }
}
